// extracted by mini-css-extract-plugin
export var center = "Text-center-tqUcq";
export var left = "Text-left-ICup2";
export var right = "Text-right-NRt3H";